import React from 'react';

import {
  DatabaseProps,
  HTMLViaNotesProps,
  ProjectTheme,
  TalentTrackerProps,
} from '@interfaces/projects';

import Database from './Layouts/Database';
import HTMLViaNotes from './Layouts/HTMLViaNotes';
import TalentTracker from './Layouts/TalentTracker';

// Combined type for the ProjectLayout component as a direct union
export type ProjectLayoutProps<TData, TValue> =
  | DatabaseProps<TData, TValue>
  | TalentTrackerProps
  | HTMLViaNotesProps;

const ProjectLayout = <TData, TValue>(props: ProjectLayoutProps<TData, TValue>): JSX.Element => {
  const { project } = props;

  // Type guard to narrow the props based on project theme
  switch (project.theme) {
    case ProjectTheme.TalentTracker:
      return <TalentTracker {...(props as TalentTrackerProps)} />;
    case ProjectTheme.Database:
      return <Database {...(props as DatabaseProps<TData, TValue>)} />;
    case ProjectTheme.HTMLViaNotes:
      return <HTMLViaNotes {...(props as HTMLViaNotesProps)} />;
  }
};

export default ProjectLayout;
